import PropTypes from "prop-types";

import { READ_ALOUD_SPEEDS } from "@/view/constants/readAloudSpeeds/readAloudSpeeds";
import ReadAloudSpeedOption from "../ReadAloudSpeedOption";
import { listCss } from "./ReadAloudOptions.style";

const propTypes = {
  buttonRef: PropTypes.object,
  contentId: PropTypes.string,
  currentLevelId: PropTypes.string,
  currentPlaybackRate: PropTypes.object,
  headerContentId: PropTypes.string,
  setCurrentPlaybackRate: PropTypes.func,
  setIsPopOutVisible: PropTypes.func,
};

const ReadAloudOptions = ({
  buttonRef,
  contentId,
  currentLevelId,
  currentPlaybackRate,
  headerContentId,
  setIsPopOutVisible,
  setCurrentPlaybackRate,
}) => {
  const onSelectOption = (speed) => {
    setCurrentPlaybackRate(speed);
    setIsPopOutVisible(false);

    requestAnimationFrame(() => {
      buttonRef?.current?.focus();
    });
  };

  return (
    <ul role="list" css={listCss}>
      {Object.keys(READ_ALOUD_SPEEDS).map((rate) => {
        const { label } = READ_ALOUD_SPEEDS[rate];
        const isSelected = label === currentPlaybackRate.label;
        const dataProps = { "data-qa-selector": "read-aloud-rate-button" };
        const ariaProps = { "aria-selected": isSelected };

        const eventProperties = {
          objectType: "Content",
          actionName: "Read",
          streamProperties: {
            content_type: "Article",
            description: `Read aloud speed set to ${label}`,
            content_id: currentLevelId,
            article_header_content_id: headerContentId,
            article_story_content_id: contentId,
          },
        };

        return (
          <ReadAloudSpeedOption
            key={label}
            ariaProps={ariaProps}
            dataProps={dataProps}
            eventProperties={eventProperties}
            isSelected={isSelected}
            onSelectOption={onSelectOption}
            speed={READ_ALOUD_SPEEDS[rate]}
          />
        );
      })}
    </ul>
  );
};

ReadAloudOptions.propTypes = propTypes;

export default ReadAloudOptions;
